import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { EmployeeAuthProvider } from "@/hooks/useEmployeeAuth";
import { EmployeeSecurityBoundary } from "@/components/employee/EmployeeLayout";
import { PortalErrorBoundary } from "@/components/PortalErrorBoundary";

// Employee portal shell. Password reset and setup live OUTSIDE this layout
// (src/routes/employee_/): those pages do their own token exchange, and the
// provider's session bootstrap must not race it.
export const Route = createFileRoute("/employee")({
  component: EmployeePortalLayout,
});

function EmployeePortalLayout() {
  // Login needs the auth provider, not employee business readiness. Location
  // advances before the old outlet commits, so select only the committed leaf.
  const isEntryRoute = useRouterState({
    select: state => {
      const leaf = state.matches[state.matches.length - 1];
      return leaf?.routeId === "/employee/login" ||
        (leaf?.routeId === "/employee/$" && leaf.status === "notFound");
    },
  });
  return (
    <EmployeeAuthProvider>
      {isEntryRoute ? <PortalErrorBoundary /> : (
        <EmployeeSecurityBoundary>
          <PortalErrorBoundary />
        </EmployeeSecurityBoundary>
      )}
    </EmployeeAuthProvider>
  );
}
